﻿import React, { useState, useEffect, Fragment, useRef } from 'react';
import { Breadcrumbs, Tabs } from 'components/navigation';
import { LinkButton, Button } from 'components/buttons'
import { ListingTable } from "components/listing";
import './AlertListing.css';
import { PageRestricted } from 'pages/errors/page-restricted';
import { AlertService, AssetService, EmployeeReviewsService, LinkService } from 'services';
import { ShowHide } from "components/layout";
import { Tooltip } from 'components/tooltip';
import { Filter, FilterButton } from 'components/filtering';
import { useDispatch, useSelector } from 'react-redux';
import { SetFiltering, SetRouting } from 'state/actions';
import { FormTextInput, FormLocationSelector } from "components/form-fields";
import { useParams } from 'react-router';
import { useDebounce } from "hooks/useDebounce";
import { DateToLocal } from "components/dates";
import { Icon, Intent, Position } from '@blueprintjs/core';
import { AssetStatus, EmployeeCircleStatus } from 'components/status';
import { LicenceBureauService } from "services/LicenceBureauService";
import { Modal, NotificationToaster } from "components/notifications";
import { useNavigate } from 'react-router-dom';
import { InstantReportButton } from 'components/reporting/InstantReportButton';
import { CommentModal, UnknownEmployeeModal } from 'pages/alert-type/alert/modal';
import { UserHasAccess, UserHasAccessActions } from "components/user-access";
import { noPerformReviewAccessMessage, noReviewTopicAccessMessage } from 'pages/employee-reviews/shared';
import { DayDetailModal } from 'pages/vehicle/day-detail-modal';
import classNames from 'classnames';
import axios from 'axios';
import moment from "moment";

const pendingReviewAlertTypeKey = "employee-reviews-pending";
const signOffReviewAlertTypeKey = "employee-reviews-sign-off";
const performReviewAction = "EmployeeReview:Perform";
const reviewTopicsUnavailableMessage = "The requirements for this review could not be read. Please try again.";

export function AlertListing(props) {
    const queryParams = new URLSearchParams(window.location.search);
    const passedSearchTerm = queryParams.get("searchTerm") ?? "";
    const passedPageNo = parseInt(queryParams.get("pageNo") ?? "1");
    const passedAlertStatus = queryParams.get("alertStatus") ?? "Active";
    const defaultRecordSize = 25;
    const debounceTimeout = 750;
    const unknownEmployeeEditAlertAuthorised = UserHasAccess("TachoAlerts:Dismiss");
    const unknownEmployeeDismissAlertAuthorised = UserHasAccess("TachoAlerts:Dismiss");
    const canPerformReviews = UserHasAccess(performReviewAction);
    const userActions = useSelector(state => state.loggedInUser.actions);
    const defaultNoDataMessage = "No Alerts found.";
    const alertsStateName = "alerts"

    const [tableSortBy, setTableSortBy] = useState({ headerName: "Employee", sortName: "Entity.Employee.FullNameReversed" });
    const [tableSortDir, setTableSortDir] = useState("A");
    const [totalRecords, setTotalRecords] = useState(0);
    const [tableRows, setTableRows] = useState([]);
    const [searchTerm, setSearchTerm] = useState(passedSearchTerm);
    const [pageNumber, setPageNumber] = useState(1);
    const [paramDefinedPageNumber, setParamDefinedPageNumber] = useState(passedPageNo);
    const [pageSize, setPageSize] = useState(defaultRecordSize);
    const [loadingData, setLoadingData] = useState(true);
    const [showFilters, setShowFilters] = useState(false);
    const [appliedFilters, setAppliedFilters] = useState([]);
    const [pageFilters, setPageFilters] = useState([]);
    const [tableHeaders, setTableHeaders] = useState([]);
    const [sortableTableHeaders, setSortableTableHeaders] = useState([]);
    const [loadedFilters, setLoadedFilters] = useState(false);

    var navigate = useNavigate();
    const dispatch = useDispatch();

    const [selectedLocations, setSelectedLocations] = useState([]);
    const [useHierarchy, setUseHierarchy] = useState(true);
    const locationListOnFilterOpen = useRef(selectedLocations);
    const inputSearchRef = useRef(null);

    const { alertTypeKey } = useParams();
    const debouncedSearchTerm = useDebounce(searchTerm, debounceTimeout);
    const [emptyListingMessage, setEmptyListingMessage] = useState(defaultNoDataMessage);
    const [validPermission, setValidPermission] = useState(true);
    const [alertType, setAlertType] = useState(null);
    const [statusTabs, setStatusTabs] = useState([
        { key: "ACTIVE", title: "Active", selected: passedAlertStatus === "Active" },
        { key: "DISMISSED", title: "Dismissed", selected: !(passedAlertStatus === "Active") },
    ]);
    const [currentStatusTab, setCurrentStatusTab] = useState(passedAlertStatus);
    const [generatingReportInstanceId, setGeneratingReportInstanceId] = useState();
    const [reportButtonDisabled, setReportButtonDisabled] = useState(false);
    const [reportDownloading, setReportDownloading] = useState(false);

    // Assign journey modal
    const [showAlertModal, setShowAlertModal] = useState(false);
    const [modalContents, setModalContents] = useState(null);
    const [modalTitle, setModalTitle] = useState("");
    const [isDismissibleButtonDisabled, setIsDismissibleButtonDisabled] = useState(false);

    //Day detail modal
    const [showDayDetailModal, setShowDayDetailModal] = useState(false);
    const [dayDetailModalAssetId, setDayDetailModalAssetId] = useState(0);
    const [dayDetailModalDate, setDayDetailModalDate] = useState(null);
    const [ownershipMapping, setOwnershipMapping] = useState([]);
    const [assetStatusesMapping, setAssetStatusesMapping] = useState([]);
    const [vehicleActivitiesMapping, setVehicleActivitiesMapping] = useState([]);

    const [reviewTopics, setReviewTopics] = useState(null);
    const [reviewTopicsLoadFailed, setReviewTopicsLoadFailed] = useState(false);

    useEffect(() => {
        axios.all([
            AlertService.getAlertTypes(true, false),
            AssetService.getAssetOptions(),
            AssetService.getActivityTypes(),
        ]).then(axios.spread(function (getAlertTypesResponse, assetOptionsResponse, activityTypesResponse) {
            if (assetOptionsResponse != null) {
                setOwnershipMapping(assetOptionsResponse.assetOwnerships.map((x) => {
                    return { "name": x.name, "colours": x.colour, "id": x.id, "className": x.style, "icon": x.icon }
                }));
                setAssetStatusesMapping(assetOptionsResponse.assetStatuses.map((x) => {
                    return { "name": x.name, "colours": x.colour, "id": x.id }
                }));
            }

            if (activityTypesResponse != null) {
                setVehicleActivitiesMapping(activityTypesResponse.map((x) => {
                    return { "name": x.name, "colours": x.colour, "id": x.id }
                }));
            }

            var selectedAlertType = getAlertTypesResponse.find(function (a) {
                return a.key === alertTypeKey;
            });

            // The alert types endpoint omits any type the user's actions do not cover, so a key that
            // is missing from the response is a refusal and the page has nothing left to load.
            if (selectedAlertType == null) {
                setValidPermission(false);
                setLoadingData(false);
                return;
            }

            setAlertType(selectedAlertType);

            AlertService.getAlertFilters(selectedAlertType.alertTypeId).then(alertFiltersEnabled => {

                let filterArray = [];
                //The ordering will be logical rather than alphabetical
                let itemStates = [
                    { id: "Active", name: "Active" },
                    { id: "Away", name: "Away" },
                ];

                let itemTypes = [
                    { id: "Core", name: "Core" },
                    { id: "Agency", name: "Agency" },
                ];

                switch (selectedAlertType.entityType.name.toLowerCase()) {
                    case 'employee':
                        filterArray = [
                            {
                                "displayName": "Status", "name": "EntityStatus", "items": [
                                    ...itemStates
                                ]
                            },
                            {
                                "displayName": "Type", "name": "EntityType", "items": [
                                    ...itemTypes
                                ]
                            }
                        ];
                        break;
                    case 'asset':
                        let itemOwnership = [
                            { "id": "Owned", "name": "Owned" },
                            { "id": "Hired", "name": "Hired" },
                            { "id": "Loaned", "name": "Loaned" },
                            { "id": "Leased", "name": "Leased" },
                            { "id": "Sold", "name": "Sold" },
                            { "id": "Returned", "name": "Returned" }
                        ];

                        filterArray = [
                            {
                                "displayName": "Ownership", "name": "EntityOwnership", "items": [
                                    ...itemOwnership
                                ]
                            }
                        ];

                        break;
                    default:
                }

                if (
                    alertTypeKey === "licence-check-critical" ||
                    alertTypeKey === "licence-check-high" ||
                    alertTypeKey === "licence-check-medium" ||
                    alertTypeKey === "licence-check-low" ||
                    alertTypeKey === "grey-fleet"
                ) {
                    filterArray = [
                        {
                            displayName: "Status",
                            name: "EntityStatus",
                            items: [...itemStates],
                        },
                        {
                            displayName: "Type",
                            name: "EntityType",
                            items: [...itemTypes],
                        },
                    ];
                }

                let filters =
                    alertFiltersEnabled.filter(function (f) { return f.key.toString() !== 'Location'; })
                        .map(function (f) {
                            return {
                                name: f.key,
                                displayName: f.value,
                                value: f.value
                            }

                        });

                dispatch(SetFiltering(alertsStateName, filters));

                let locs =
                    alertFiltersEnabled.filter(function (f) { return f.key.toString() === 'Location'; })
                        .map(function (f) { return parseInt(f.value) });

                setSelectedLocations(locs);

                setLoadedFilters(true);

                setPageFilters(filterArray);
            });
        }));

    }, []);

    useEffect(() => {
        if (alertTypeKey !== pendingReviewAlertTypeKey || !canPerformReviews) {
            return;
        }

        EmployeeReviewsService.getOptions().then((reviewOptions) => {
            const topics = reviewOptions?.topics ?? [];

            setReviewTopics(topics);
            setReviewTopicsLoadFailed(topics.length === 0);
        }, () => {
            setReviewTopics([]);
            setReviewTopicsLoadFailed(true);
        });

    }, [alertTypeKey, canPerformReviews]);

    // Rows are built once per search, so the topics have to be in before the first build or every
    // link is decided against requirements that have not arrived.
    const reviewTopicsLoaded = alertTypeKey !== pendingReviewAlertTypeKey || !canPerformReviews || reviewTopics != null;

    useEffect(() => {
        //If the filers are loaded we know the locations should be as well so we can check that there are some
        if (loadedFilters && (!selectedLocations || selectedLocations.length === 0)) {
            setTableRows([]);
            setTotalRecords(0);
            setLoadingData(false);
            return;
        }

        //This will trigger if the data changes, but will only process if the loadingData is set to true.
        if (loadingData
            && pageFilters.length > 0
            && selectedLocations != null
            && alertType != null
            && loadedFilters
            && reviewTopicsLoaded) {

            const alertRequest = {
                requestCount: pageSize,
                pageNumber: paramDefinedPageNumber ?? pageNumber,
                searchTerm: searchTerm,
                sortField: tableSortBy.sortName,
                sortDirection: tableSortDir,
                AlertTypeIds: [alertType.alertTypeId],
                filters: getAlertFiltersAsKvp()
            };

            AlertService.getAlerts(alertRequest).then(r => {

                let data = [];

                if (r?.data != null) {
                    data = r.data.map((d) => {
                        return [
                            ...mapRows(d),
                            ...mapAdditionalRows(d),
                            mapAdditionalLinks(d)
                        ];
                    })
                }

                setTableRows(data);
                setTotalRecords(r.totalCount);
                setLoadingData(false);

                setTimeout(function () {
                    if (inputSearchRef.current != null) {
                        inputSearchRef.current.focus();
                    }
                });

                //The setTotalRecords will set the page back to 1, so we have to do this here rather than earlier
                if (paramDefinedPageNumber) {
                    setPageNumber(paramDefinedPageNumber);
                    setParamDefinedPageNumber(null);
                }
            }, (error) => {
                const noAccessCode = 403;
                if (error.status === noAccessCode) {
                    setValidPermission(false);
                    return;
                }
                NotificationToaster.show(Intent.DANGER, "Unable to load alerts. Please try again.");
            }).finally(() => {
                setLoadingData(false);
            });
        }

    }, [loadingData, pageSize, pageNumber, tableSortBy, tableSortDir, appliedFilters, selectedLocations, debouncedSearchTerm, alertType, pageFilters, loadedFilters, reviewTopicsLoaded]);

    useEffect(() => {
        mapHeaders();
    }, [alertType])

    useEffect(() => {
        setLoadingData(true);
        setPageNumber(1);
        setEmptyListingMessage("No results found, please try a different search term.");
    }, [debouncedSearchTerm]);

    useEffect(() => {
        setReportButtonDisabled(selectedLocations.length === 0 || reportDownloading);

    }, [selectedLocations, reportDownloading])

    function displayDayDetailModal(assetId, date) {
        setShowDayDetailModal(true);
        setDayDetailModalAssetId(assetId);
        setDayDetailModalDate(moment(date).format('YYYY-MM-DD'));
    }

    function hideDayDetailModal() {
        setShowDayDetailModal(false);
        setDayDetailModalAssetId(0);
        setDayDetailModalDate(null);
        setLoadingData(true);
    }

    function openModal(alert) {
        //Change to switch statement when there are 3 or more modals
        if (alertTypeKey === 'unknown-employee') {
            setModalContents(<UnknownEmployeeModal alert={alert} close={closeModal} save={saveModal} />)
            setModalTitle(alertType.title);
        }
        else if (alertType.allowComments) {
            setModalContents(<CommentModal alert={alert} close={closeModal} save={saveModal} />)
            if (alert.comment) {
                setModalTitle("Edit Comment");
            }
            else {
                setModalTitle("Add Comment");
            }
        }

        setShowAlertModal(true);
    }

    function closeModal() {
        setShowAlertModal(false);
    }

    function saveModal() {
        setLoadingData(true);
        closeModal()
    }

    // Returns whether the viewing user can open the review's wizard along with the reason they
    // cannot, so the same result drives both the link and the tooltip explaining its absence.
    function resolveReviewCompletability(alert) {
        if (!canPerformReviews) {
            return { canComplete: false, reason: noPerformReviewAccessMessage };
        }

        const topicIds = alert.alertData?.topicIds ?? [];

        if (!Array.isArray(topicIds)) {
            return { canComplete: false, reason: reviewTopicsUnavailableMessage };
        }

        const topics = reviewTopics ?? [];
        const reasons = [];

        // A review type with no topics has no requirement to miss, so it is unaffected by a failed
        // read - as on the server, where the all-topics check is vacuously true for an empty list.
        if (topicIds.length > 0 && reviewTopicsLoadFailed) {
            return { canComplete: false, reason: reviewTopicsUnavailableMessage };
        }

        topicIds.forEach((topicId) => {
            const matchedTopic = topics.find((topic) => topic.id === topicId);

            // A topic the options endpoint does not return must withhold the link, never allow it.
            if (matchedTopic == null) {
                reasons.push(noReviewTopicAccessMessage);
                return;
            }

            // Blank matches the server's IsNullOrWhiteSpace tests: a blank action gates nothing, and a blank message needs a stand-in.
            const requiredAction = (matchedTopic.requiredAction ?? "").trim();
            const permissionMessage = (matchedTopic.permissionMessage ?? "").trim();

            if (requiredAction !== "" && !UserHasAccessActions(requiredAction, userActions)) {
                reasons.push(permissionMessage === "" ? noReviewTopicAccessMessage : permissionMessage);
            }
        });

        if (reasons.length > 0) {
            return { canComplete: false, reason: [...new Set(reasons)].join(" ") };
        }

        return { canComplete: true, reason: "" };
    }

    function mapHeaders() {
        const headers = [];
        const sortableHeaders = [];

        if (alertType) {
            switch (alertType.entityType.name.toLowerCase()) {
                case 'employee':
                    headers.push("Employee");
                    headers.push("Reference");
                    headers.push("Location");

                    sortableHeaders.push({ headerName: "Employee", sortName: "Entity.Employee.FullNameReversed" });
                    sortableHeaders.push({ headerName: "Reference", sortName: "Entity.Employee.Reference" });
                    sortableHeaders.push({ headerName: "Location", sortName: "Location.Name" });
                    break;
            }

            switch (alertTypeKey) {
                case 'licence-bureau-low':
                case 'licence-bureau-high':
                case 'licence-bureau-critical':
                    headers.push('Due Date');
                    headers.push('Type');
                    headers.push('Information');

                    sortableHeaders.push({ headerName: "Due Date", sortName: "AlertData.DueDate" });
                    sortableHeaders.push({ headerName: "Type", sortName: "AlertData.Title" });
                    sortableHeaders.push({ headerName: "Information", sortName: "AlertData.Description" });
                    break;
                case 'walkaround-check-defects':
                    headers.push('Vehicle registration');
                    headers.push('Fleet Number')
                    headers.push('Asset Location')
                    headers.push('Employee');
                    headers.push('Completed date');
                    headers.push('Defect count');

                    setTableSortBy({ headerName: "Vehicle registration", sortName: "Entity.Asset.Registration" })
                    sortableHeaders.push({ headerName: "Employee", sortName: "AlertData.EmployeeFullName" });
                    sortableHeaders.push({ headerName: "Vehicle registration", sortName: "Entity.Asset.Registration" });
                    sortableHeaders.push({ headerName: "Completed date", sortName: "AlertData.EndDate" });
                    sortableHeaders.push({ headerName: "Defect count", sortName: "AlertData.DefectCount" });
                    break;
                case 'asset-registration-error':
                    headers.push('Vehicle registration');
                    headers.push('Original registration');
                    headers.push('Fleet Number')
                    headers.push('Update date');
                    headers.push('Location');

                    setTableSortBy({ headerName: "Update date", sortName: "EventTime" })

                    break;
                case 'awaiting-printout':
                    headers.push('Card number');
                    headers.push('Awaiting Data Date');
                    break;
                case 'unknown-employee':
                    headers.push('Vehicle registration');
                    headers.push('Vehicle Type');
                    headers.push('Fleet Number');
                    headers.push('Driver Name');
                    headers.push('Location');
                    headers.push('Shift Start');
                    headers.push('Shift End');

                    setTableSortBy({ headerName: "Vehicle registration", sortName: "Entity.Asset.Registration" })
                    sortableHeaders.push({ headerName: "Vehicle registration", sortName: "Entity.Asset.Registration" });
                    sortableHeaders.push({ headerName: "Vehicle Type", sortName: "Entity.Type.Name" });
                    sortableHeaders.push({ headerName: "Fleet Number", sortName: "Entity.Asset.FleetNumber" });
                    sortableHeaders.push({ headerName: "Driver Name", sortName: "AlertData.DriverFirstNames" });
                    sortableHeaders.push({ headerName: "Location", sortName: "Location.Name" });
                    sortableHeaders.push({ headerName: "Shift Start", sortName: "DataStartDate" });
                    sortableHeaders.push({ headerName: "Shift End", sortName: "DataEndDate" });
                    break;
                case 'licence-check-low':
                case 'licence-check-medium':
                case 'licence-check-high':
                case 'licence-check-critical':
                    headers.push('Type');
                    headers.push('Description');

                    sortableHeaders.push({ headerName: "Employee", sortName: "Entity.Employee.FullNameReversed" });
                    sortableHeaders.push({ headerName: "Reference", sortName: "Entity.Employee.Reference" });
                    sortableHeaders.push({ headerName: "Location", sortName: "Location.Name" });
                    sortableHeaders.push({ headerName: "Type", sortName: "AlertData.Title" });
                    sortableHeaders.push({ headerName: "Description", sortName: "AlertData.Message" });

                    break;
                case 'grey-fleet':
                    headers.push('Registration');
                    headers.push('Action');

                    sortableHeaders.push({ headerName: "Employee", sortName: "Entity.Employee.FullNameReversed" });
                    sortableHeaders.push({ headerName: "Reference", sortName: "Entity.Employee.Reference" });
                    sortableHeaders.push({ headerName: "Location", sortName: "Location.Name" });
                    sortableHeaders.push({ headerName: "Registration", sortName: "AlertData.Registration" });
                break;
                case 'employee-actions':
                    headers.push('Policy Name');
                    headers.push('Outstanding Actions');
                    headers.push('Date due from');
                    headers.push('Overdue');
                    sortableHeaders.push({ headerName: "Location", sortName: "Location.Name" });
                    sortableHeaders.push({ headerName: "Policy Name", sortName: "AlertData.PolicyName" });
                    sortableHeaders.push({ headerName: "Outstanding Actions", sortName: "AlertData.ActionCount" });
                    sortableHeaders.push({ headerName: "Date due from", sortName: "AlertData.StartDate" });
                    sortableHeaders.push({ headerName: "Overdue", sortName: "AlertData.Overdue" });
                    break;
                case pendingReviewAlertTypeKey:
                    headers.push('Review Type');
                    headers.push('Due Date');

                    sortableHeaders.push({ headerName: "Review Type", sortName: "AlertData.ReviewTypeName" });
                    sortableHeaders.push({ headerName: "Due Date", sortName: "AlertData.DueDate" });
                    break;
                case signOffReviewAlertTypeKey:
                    headers.push('Review Type');
                    headers.push('Completed Date');
                    headers.push('Sign-Off Method');

                    sortableHeaders.push({ headerName: "Review Type", sortName: "AlertData.ReviewTypeName" });
                    sortableHeaders.push({ headerName: "Completed Date", sortName: "AlertData.CompletionDate" });
                    break;
            }

            // Every row carries a trailing cell for the action buttons, so the header row needs one
            // to match it or the columns misalign.
            headers.push('');

            setTableHeaders(headers);
            setSortableTableHeaders(sortableHeaders);
        }
    }

    function mapRows(alert) {
        if (alertType.entityType.name.toLowerCase() === 'asset') {
            return [
                <Fragment key={alert.alertId}>
                    <div className="nowrap inline-items no-spacing">
                        <AssetStatus
                            statusId={alert.entity.status?.id}
                            ownershipId={alert.entity.asset?.ownership?.id}
                            tooltip={getStatusTooltip(alert.entity)}
                            statusAttributeMappings={assetStatusesMapping}
                            ownershipAttributeMappings={ownershipMapping}
                        />
                        <span>{alert.entity.asset.registration}</span>
                    </div>
                </Fragment>,
            ];
        }

        return [
            
            <Fragment key={alert.alertId}>
                <div className="inline-items no-spacing">
                    <EmployeeCircleStatus status={alert.entity.status?.name} tooltip={getStatusTooltip(alert.entity)} isRoaming={alert.entity.employee.isRoaming} isAgency={alert.entity.type?.name?.toLowerCase() === "agency"} />
                    <span className="break-word">{alert.entity.employee.fullNameReversed}</span>
                </div>
            </Fragment>,
            <span className="break-word" key={`Reference-${alert.alertId}`}>{alert.entity.employee.reference}</span>,
            <span className="break-word" key={`Location-${alert.alertId}`}>{alert.location.name}</span>,
        ];
    }

    function mapAdditionalLinks(alert) {
        const links = [];
        let activityDate = null;
        let returnParams = "";        

        switch (alertType.entityType.name.toLowerCase()) {
            case 'employee':
                activityDate = moment(alert.externalKey).isValid() ? `&activityDate=${moment(alert.externalKey).format('YYYY-MM-DD')}&openDayDetail=true` : '';
                returnParams = `&pageNo=${pageNumber}&searchTerm=${searchTerm}&alertType=${alertTypeKey}`;
                if (alertType.isDismissable)
                    returnParams = returnParams + `&alertStatus=${currentStatusTab}`;
                links.push(<Tooltip position={Position.TOP} content={`Employee Calendar`}>
                    <LinkButton
                        href={`${window.env.VISION_URL}/#/Drivers/RedirectToCalendar?driverId=${alert.entity.entityId}${activityDate}${returnParams}`}
                        icon={"calendar"}
                        externalLink={true}
                        minimal={true}
                        iconOnly={true}
                        text="Calendar"
                        large={false}
                    />
                </Tooltip>);
                links.push(<Tooltip position={Position.TOP} content="Employee Profile">
                    <LinkButton
                        href={`${window.env.VISION_URL}/#/Drivers/RedirectToProfile?employeeId=${alert.entity.entityId}${returnParams}`}
                        icon={"person"}
                        externalLink={true}
                        minimal={true}
                        iconOnly={true}
                        text="Profile"
                        large={false}
                    />
                </Tooltip>);
                break;
            case 'asset':
                returnParams = `pageNo=${pageNumber}&searchTerm=${searchTerm}&alertType=${alertTypeKey}`;
                if (alertType.isDismissable) {
                    returnParams = `${returnParams}&alertStatus=${currentStatusTab}`;
                }

                links.push(
                    <Tooltip position={Position.TOP} content="Asset Profile" key={`Asset-Profile-${alert.alertId}`}>
                        <LinkButton
                            href={LinkService.getVehicleProfileUrl(alert.entity.entityId, 'details', returnParams)}
                            icon={"truck"}
                            minimal={true}
                            iconOnly={true}
                            text="Profile"
                            large={false}
                        />
                    </Tooltip>);
                break;
        }

        switch (alertTypeKey) {
            case 'licence-bureau-low':
            case 'licence-bureau-high':
            case 'licence-bureau-critical':
                links.push(<Tooltip content="View in Licence Bureau" key={`Link-LB-${alert.alertId}`}>
                    <Button
                        icon={"link"}
                        minimal={true}
                        iconOnly={true}
                        large={false}
                        onClick={() => navigateToLicenceBureau(alert.alertData.organisationId, alert.externalKey)}
                    />
                </Tooltip>);
                break;
            case 'walkaround-check-defects':
                links.push(<Tooltip content="View walkaround check report" key={`Link-To-Defect-${alert.alertId}`}>
                    <Button
                        icon={"link"}
                        minimal={true}
                        iconOnly={true}
                        large={false}
                        onClick={() => navigateToWalkaroundDetails(alert.externalKey)}
                    />
                </Tooltip>);
                break;
            case 'unknown-employee':
                links.push(
                    <Tooltip content="Day Detail" key={`Day-Detail-${alert.alertId}`}>
                        <Button
                            large={false}
                            minimal={true}
                            iconOnly={true}
                            icon={'calendar'}
                            id={`Day-Detail-Modal${alert.alertId}${alert.entity.entityId}`}
                            onClick={() => displayDayDetailModal(alert.entity.entityId, alert.dataStartDate)}
                        />
                    </Tooltip>);
                break;
            case 'grey-fleet':
                links.push(
                    <Tooltip position={Position.TOP} content="Grey Fleet Check" key={`Grey-Fleet-Check-${alert.alertData.checkId}`}>
                        <LinkButton
                            href={`/licence-checking/grey-fleet/check/${alert.alertData.checkId}`}
                            large={false}
                            minimal={true}
                            iconOnly={true}
                            icon={"truck"}
                        />
                    </Tooltip>);
            break;
            case 'employee-actions':
                links.push(
                    <Tooltip content="View Action" key={`View-Action-${alert.alertId}`}>
                        <LinkButton
                            icon={"link"}
                            externalLink={true}
                            minimal={true}
                            iconOnly={true}
                            text="View Actions"
                            large={false}
                            href={`/employee/${alert.entity.entityId}/documents/policies`}
                        />
                    </Tooltip>);
            break;
            case pendingReviewAlertTypeKey: {
                const pendingReviewId = alert.alertData?.pendingReviewId;

                if (pendingReviewId != null) {
                    const completability = resolveReviewCompletability(alert);

                    if (completability.canComplete) {
                        links.push(
                            <Tooltip content="Complete Review" key={`Complete-Review-${alert.alertId}`}>
                                <LinkButton
                                    icon={"link"}
                                    minimal={true}
                                    iconOnly={true}
                                    text="Complete Review"
                                    large={false}
                                    href={`/employee-reviews/pending-reviews/${pendingReviewId}/complete`}
                                />
                            </Tooltip>);
                    }
                    else {
                        // The reason is the span's accessible name because Icon marks itself
                        // aria-hidden. Named by attribute rather than Icon's title: Blueprint renders
                        // title into the SVG as text, which getByText matches with no tooltip opened.
                        links.push(
                            <Tooltip content={completability.reason} key={`Complete-Review-${alert.alertId}`}>
                                <span
                                    id={`Complete-Review-Unavailable-${alert.alertId}`}
                                    role="img"
                                    aria-label={completability.reason}
                                    tabIndex={0}
                                    className={classNames('bp6-button', 'bp6-minimal', 'bp6-disabled', 'btn-form')}
                                >
                                    <Icon icon="link" className="bp6-text-muted" />
                                </span>
                            </Tooltip>);
                    }
                }
            }
            break;
            case signOffReviewAlertTypeKey: {
                const reviewId = alert.alertData?.reviewId;

                if (reviewId != null) {
                    links.push(
                        <Tooltip content="View Review" key={`View-Review-${alert.alertId}`}>
                            <LinkButton
                                icon={"link"}
                                minimal={true}
                                iconOnly={true}
                                text="View Review"
                                large={false}
                                href={`/employee-reviews/completed-reviews/${reviewId}`}
                            />
                        </Tooltip>);
                }
            }
            break;
        }

        // Neither review type has an openModal case of its own, so with comments off a Use_Modal = 1
        // record would open an empty modal. With comments on it falls to the generic CommentModal.
        const emptyReviewModal = !alertType.allowComments
            && (alertTypeKey === pendingReviewAlertTypeKey || alertTypeKey === signOffReviewAlertTypeKey);

        if (alertType.useModal && !emptyReviewModal && (currentStatusTab === 'Active' || alertType.allowComments) && (unknownEmployeeEditAlertAuthorised || alertTypeKey !== 'unknown-employee')) {
            let icon = "edit";
            if (alertType.allowComments) {
                icon = "comment";
            }

            links.push(<Tooltip content={alertType.modalActionText} key={`Edit-${alert.alertId}`}>
                <Button
                    large={false}
                    minimal={true}
                    iconOnly={true}
                    icon={icon}
                    id={alert.alertId.toString()}
                    onClick={() => openModal(alert)}
                    intent={alert.comment ? Intent.PRIMARY : null}
                />
            </Tooltip>);
        }

        if (alertType.isDismissable && (unknownEmployeeDismissAlertAuthorised || alertTypeKey !== 'unknown-employee')) {
            links.push(<Tooltip content={currentStatusTab === 'Active' ? "Dismiss Alert" : "Reactivate Alert"} key={`Dismiss-Tooltip-${alert.alertId}`}>
                <Button
                    large={false}
                    minimal={true}
                    iconOnly={true}
                    icon={currentStatusTab === 'Active' ? "remove" : "reset"}
                    id={`Dismiss-${alert.alertId}`}
                    onClick={() => onStatusUpdateButtonClick(alert, currentStatusTab)}
                    disabled={isDismissibleButtonDisabled}
                />
            </Tooltip>);
        }

        if (links.length > 0) {
            return <div className="nowrap inline-items no-spacing">
                {links}
            </div>
        }

        return <Fragment />
    }

    function formatDriverName(driverFirstNames, driverLastName) {
        if (!driverFirstNames && !driverLastName) {
            return "-";
        }

        return `${!driverFirstNames ? "" : driverFirstNames} ${!driverLastName ? "" : driverLastName}`;
    }

    function mapAdditionalRows(alert) {
        switch (alertTypeKey) {
            case 'licence-bureau-low':
            case 'licence-bureau-high':
            case 'licence-bureau-critical':
                return [
                    <DateToLocal format='DD/MM/YYYY'>{alert.alertData.dueDate}</DateToLocal>,
                    alert.alertData.title,
                    alert.alertData.description
                ];
            case 'awaiting-printout':
                return [
                    alert.entity.employee?.cardNumber,
                    <DateToLocal format='DD/MM/YYYY' key={alert.alertId}>{alert.externalKey}</DateToLocal>
                ];
            case 'walkaround-check-defects':
                return [
                    alert.entity.asset.fleetNumber === "" ? "-" : alert.entity.asset.fleetNumber,
                    <span className="break-word" key={`Location-${alert.alertId}`}>{alert.location.name}</span>,
                    alert.alertData.employeeFullName,
                    <DateToLocal key={alert.externalKey} format='DD/MM/YYYY'>{alert.alertData.endDate}</DateToLocal>,
                    alert.alertData.defectCount,
                ];
            case 'asset-registration-error':
                return [
                    alert.alertData.assetRegistration,
                    alert.entity.asset.fleetNumber === "" ? "-" : alert.entity.asset.fleetNumber,
                    <DateToLocal format='DD/MM/YYYY' key={alert.alertId}>{alert.eventTime}</DateToLocal>,
                    <span className="break-word" key={`Location-${alert.alertId}`}>{alert.location.name}</span>,
                ];
            case 'unknown-employee':
                return [
                    alert.entity.type.name,
                    alert.entity.asset.fleetNumber === "" ? "-" : alert.entity.asset.fleetNumber,
                    formatDriverName(alert.alertData.driverFirstNames, alert.alertData.driverLastName),
                    <span className="break-word" key={`Location-${alert.alertId}`}>{alert.location.name}</span>,
                    <DateToLocal key={"ShiftStartTable - " + alert.alertId}>{alert.dataStartDate}</DateToLocal>,
                    <DateToLocal key={"ShiftEndTable - " + alert.alertId}>{alert.dataEndDate}</DateToLocal>,
                ];
            case 'licence-check-low':
            case 'licence-check-medium':
            case 'licence-check-high':
            case 'licence-check-critical':
                return [
                    alert.alertData.title,
                    alert.alertData.message
                ];
            case 'grey-fleet':
                return [
                    alert.alertData.registration,
                    alert.alertData.action
                ];
            case 'employee-actions':
                return [
                    <span className="break-word" key={`Policy-Name-${alert.alertId}`}>{alert.alertData.policyName}</span>,
                    alert.alertData.actionCount,
                    <DateToLocal format='DD/MM/YYYY' key={alert.alertId}>{alert.alertData.startDate}</DateToLocal>,
                    alert.alertData.overdue ? "Yes" : "No"
                ];
            // moment reads undefined as the current time, so an absent payload date has to coalesce
            // to null or DateToLocal renders today.
            case pendingReviewAlertTypeKey:
                return [
                    <span className="break-word" key={`Review-Type-${alert.alertId}`}>{alert.alertData?.reviewTypeName ?? "-"}</span>,
                    <DateToLocal format='DD/MM/YYYY' key={alert.alertId}>{alert.alertData?.dueDate ?? null}</DateToLocal>
                ];
            case signOffReviewAlertTypeKey:
                return [
                    <span className="break-word" key={`Review-Type-${alert.alertId}`}>{alert.alertData?.reviewTypeName ?? "-"}</span>,
                    <DateToLocal format='DD/MM/YYYY' key={alert.alertId}>{alert.alertData?.completionDate ?? null}</DateToLocal>,
                    alert.alertData?.signOffMethodName ?? "-"
                ];
        }
        return [];
    }

    function getStatusTooltip(entity) {
        if (entity.asset?.registration) {
            return `${entity.status?.name} ${entity.asset?.ownership?.name} ${entity.type?.name?.toLowerCase()}`;
        }

        return `${entity.status?.name} ${entity.type?.name?.toLowerCase()} employee`;
    }

    function onTableSort(header, direction) {
        setTableSortBy(header);
        setTableSortDir(direction);
        setLoadingData(true);
    }

    function onPagingChange(newPageNumber, newPageSize) {
        setPageNumber(newPageNumber);
        setPageSize(newPageSize);
        setLoadingData(true);
    }

    function onFilterChange(listingFilters) {
        setLoadingData(true);
        setPageNumber(1);
        setEmptyListingMessage("No results found, please try a different filter.");
        setAppliedFilters(listingFilters);
    }

    function onToggleFilter() {
        setShowFilters((prevState) => {
            return !prevState;
        })
    }

    function onSearchChange(item) {
        setSearchTerm(item.target.value);
    }

    function onLocationListOpened() {
        locationListOnFilterOpen.current = selectedLocations;
    }

    function onLocationListClose() {
        if (locationListOnFilterOpen.current.toString() !== selectedLocations.toString()) {
            setLoadingData(true);
        }
    }

    function navigateToLicenceBureau(orgId, taskId) {
        LicenceBureauService.navigateToLicenceBureau(orgId,
            taskId,
            () => NotificationToaster.show(Intent.DANGER, "Unable to load the link to the licence checking provider. Please try again."))
    }

    function onStatusUpdateButtonClick(alert, currentStatus) {
        setIsDismissibleButtonDisabled(true);

        let newStatusMap = {
            Active: 2, Dismissed: 1
        }

        if (alertTypeKey === 'unknown-employee' && newStatusMap[currentStatus] === 2) {
            AssetService.assignJourney(alert.entity.entityId, 0, alert.dataStartDate, alert.dataEndDate).then(
                () => AlertService.saveAlertStatus(alert.alertId, newStatusMap[currentStatus], alert.comment).then(
                    () => {
                        setIsDismissibleButtonDisabled(false);
                        NotificationToaster.show(Intent.SUCCESS, "Journey has been successfully processed.");
                        setLoadingData(true);
                    },
                    () => {
                        setIsDismissibleButtonDisabled(false);
                        NotificationToaster.show(Intent.DANGER, "Unable to dismiss notification. Please try again.");
                    }),
                () => {
                    setIsDismissibleButtonDisabled(false);
                    NotificationToaster.show(Intent.DANGER, "Unable to assign a journey. Please try again.");
                }
            );
        }
        else if (alertTypeKey === 'unknown-employee' && newStatusMap[currentStatus] === 1) {
            AssetService.deleteJourney(alert.entity.entityId, 0, alert.dataStartDate, alert.dataEndDate).then(
                () => AlertService.saveAlertStatus(alert.alertId, newStatusMap[currentStatus], alert.comment).then(
                    () => {
                        setIsDismissibleButtonDisabled(false);
                        NotificationToaster.show(Intent.SUCCESS, "Journey has been successfully processed.");
                        setLoadingData(true);
                    },
                    () => {
                        setIsDismissibleButtonDisabled(false);
                        NotificationToaster.show(Intent.DANGER, "Unable to dismiss notification. Please try again.");

                    }),
                () => {
                    setIsDismissibleButtonDisabled(false);
                    NotificationToaster.show(Intent.DANGER, "Unable to delete a journey. Please try again.");
                }
            );
        }
        else {
            const successMessage = currentStatus === 'Active'
                ? "Alert has been successfully dismissed."
                : "Alert has been successfully reactivated.";
            const failureMessage = currentStatus === 'Active'
                ? "Unable to dismiss alert. Please try again."
                : "Unable to reactivate alert. Please try again.";

            AlertService.saveAlertStatus(alert.alertId, newStatusMap[currentStatus], alert.comment).then(
                () => {
                    setIsDismissibleButtonDisabled(false);
                    NotificationToaster.show(Intent.SUCCESS, successMessage);
                    setLoadingData(true);
                },
                () => {
                    setIsDismissibleButtonDisabled(false);
                    NotificationToaster.show(Intent.DANGER, failureMessage);
                });
        }
    }

    function onTabClick(index) {

        var clonedTabs = [
            ...statusTabs
        ];

        clonedTabs = clonedTabs.map(function (t, i) {
            return {
                ...t,
                selected: index === i
            }
        });
        setPageNumber(1);
        setStatusTabs(clonedTabs);
        setCurrentStatusTab(getTabNameFromIndex(index));
        setLoadingData(true);
    }

    function getTabNameFromIndex(index) {
        let tabNameMap = {
            0: 'Active', 1: 'Dismissed'
        }
        return tabNameMap[index];
    }

    function getAlertStatus() {
        return {
            key: 'AlertStatus',
            value: currentStatusTab
        };
    }

    function navigateToWalkaroundDetails(walkaroundCheckId) {
        dispatch(SetRouting('alert list', 'alert/walkaround-check-defects', null));
        navigate(AlertService.getWalkaroundCheckUrl(walkaroundCheckId));
    }

    function placeholderValue() {
        switch (alertType?.entityType.name.toLowerCase()) {
            case 'asset':
                return "Registration";
            default:
                return "Name or reference search";
        }
    }

    function getAlertFiltersAsKvp() {
        let filtersArray = appliedFilters.map(function (f) {
            return {
                key: f.name,
                ...f
            }
        }).concat(getAlertStatus());

        //Make sure any missing filter types are replaced with 'all' of that type
        //i.e. if none are selected, do not filter:
        pageFilters
            .filter(f => {
                return filtersArray.every(existing => {
                    return existing.name !== f.name
                });
            })
            .map(f => {
                return f.name
            })
            .forEach(neededFilter => {
                const filtersToAdd = pageFilters
                    .filter(o => {
                        return o.name === neededFilter
                    })
                    .map(f => {
                        return f.items.map(q => {
                            return {
                                key: f.name,
                                value: q.name
                            }
                        })
                    });

                filtersToAdd[0].forEach(element => {
                    filtersArray.push(element);
                });
            });

        selectedLocations.forEach(function (l) {
            filtersArray = [...filtersArray,
            { "key": "Location", "value": l }
            ];
        });

        return filtersArray;
    }

    function onReportGenerate() {
        setReportDownloading(true);
        const alertRequest = {
            searchTerm: searchTerm,
            sortField: tableSortBy.sortName,
            sortDirection: tableSortDir,
            AlertTypeId: alertType.alertTypeId,
            filters: getAlertFiltersAsKvp()
        };

        AlertService.postReportRequest(alertRequest).then((result) => {
            setGeneratingReportInstanceId(result);
        }, (error) => {
            NotificationToaster.show(Intent.DANGER, error)
            setGeneratingReportInstanceId(null);
            setReportDownloading(false);
        })
    }

    function onReportDownloadComplete() {
        setGeneratingReportInstanceId(null);
        setReportDownloading(false);
    }

    // Breaking the employee name collapses its cell's minimum content width to a single character, so
    // the name column needs an explicit floor or a long value in another column squashes the name.
    let columnClasses = [];

    if (alertType?.entityType.name.toLowerCase() === 'employee') {
        columnClasses = ['alert-employee-name-column'];
    }

    return (
        <Fragment>
            <ShowHide
                evaluator={validPermission}
                show={(
                    <div className="row">

                        <Breadcrumbs items={props.breadcrumbs} />

                        <h1>Alerts {alertType !== null ? '- ' + alertType.title : ''}</h1>

                        <ShowHide
                            evaluator={!loadingData && tableRows.length === 0 && pageFilters.length === 0}
                            hide={(
                                <Fragment>                                    
                                    <div className="spacer-bottom">
                                        <div className="filter-controls">
                                            <div className="inline-items">
                                                <div className="inline-item fill">
                                                    <div className="form-field-full">
                                                        <FormTextInput inputRef={inputSearchRef} placeholder={placeholderValue()} onChange={onSearchChange} value={searchTerm} large disabled={loadingData} icon="search" id="alert-search-field" />
                                                    </div>
                                                </div>
                                                
                                                <FormLocationSelector
                                                    businessArea={alertType?.locationBusinessArea?.name == null ? '' : alertType?.locationBusinessArea?.name}
                                                    loading={loadingData}
                                                    onLocationListClose={onLocationListClose}
                                                    onLocationListOpened={onLocationListOpened}
                                                    selectedLocations={selectedLocations}
                                                    setSelectedLocations={setSelectedLocations}
                                                    useLocationDefaults={false}
                                                    useHierarchy={useHierarchy}
                                                    setUseHierarchy={setUseHierarchy}
                                                    locationDefaultsToTrue={loadedFilters ? true : null}
                                                />                                              
                                                
                                                <ShowHide evaluator={(alertType?.reportName !== null && alertType?.reportName?.length > 0)}
                                                    show={
                                                        <Tooltip content="Download current view to Excel spreadsheet" position="right">
                                                            <InstantReportButton
                                                                onReportGenerate={onReportGenerate}
                                                                onReportDownloadComplete={onReportDownloadComplete}
                                                                id="downloadAlerts"
                                                                text="Download report"
                                                                reportId={generatingReportInstanceId}
                                                                buttonDisabled={reportButtonDisabled || loadingData}
                                                            />
                                                        </Tooltip>
                                                    }
                                                />         
                                                <FilterButton onToggle={onToggleFilter} filters={appliedFilters} />                                    
                                            </div>
                                            <Filter filterName={alertsStateName} visible={showFilters} filters={pageFilters} onUpdate={onFilterChange} onClickOutside={onToggleFilter} />
                                        </div>
                                    </div>                                    
                                </Fragment>
                            )}
                        />
                        <div className="spacer-bottom">
                            <ShowHide
                                evaluator={!loadingData && (alertType?.isDismissable ?? false)}
                                show={
                                    <div className="spacer-bottom">
                                        <Tabs tabs={statusTabs} onClick={onTabClick} loading={loadingData} />
                                    </div>
                                }
                            />
                        </div>
                        <ListingTable
                            id="listing-table-alerts"
                            headers={tableHeaders}
                            data={tableRows}
                            totalRecordCount={totalRecords}
                            onPagingChange={onPagingChange}
                            loadingData={loadingData}
                            noDataMessage={emptyListingMessage}
                            sortable
                            sortableHeaders={sortableTableHeaders}
                            sortedBy={tableSortBy}
                            sortedDir={tableSortDir}
                            onSort={onTableSort}
                            startPage={pageNumber}
                            columnClasses={columnClasses}
                        />
                    </div>
                )}
            />

            <Modal
                isOpen={showAlertModal}
                clickOutsideClose={false}
                onClose={() => setShowAlertModal(false)}
                title={modalTitle}
                icon="warning-sign"
                intent={Intent.DANGER}
                confirmButtonText="Dismiss"
                onConfirm={() => setShowAlertModal(false)}
                showCloseButton={false}
            >
                {modalContents}
            </Modal>

            <DayDetailModal
                showDayDetailModal={showDayDetailModal}
                closeDayDetailModal={hideDayDetailModal}
                assetId={dayDetailModalAssetId}
                date={dayDetailModalDate}
                statusAttributeMappings={assetStatusesMapping}
                ownershipAttributeMappings={ownershipMapping}
                vehicleActivityTypes={vehicleActivitiesMapping}
                key={dayDetailModalAssetId + dayDetailModalDate}
            />

            <ShowHide
                evaluator={!validPermission}
                show={(
                    <PageRestricted />
                )}
            />
        </Fragment>
    );
}